import React from "react";

// locales
import i18n from '../../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// style
import "./SelectApplyBtn.scss";

/**
 * @example
 * 			<SelectApplyBtn isdisabled={false} onclick={(e) => this.foobar(e)} />
 */
class SelectApplyBtn extends React.Component {

	// ____________________________________ onClickHandler ____________________________________

	onClickHandler(e) {
		// console.log('onClick');
		this.props.onClick(e);
		// console.log('onApplyClick');
		this.props.onApplyClick();
	}

	// ____________________________________ render ____________________________________

	render() {
		let AuthButton =
			<button
				type="button"
				className='btn btn-outline-secondary btn-outline-secondary-ing'
				onClick={(e) => this.onClickHandler(e)}>
				{i18n.t('select.apply.btn')}
			</button>;
		if (this.props.isdisabled) {
			AuthButton =
				<button
					type="button"
					className='btn btn-outline-secondary btn-outline-secondary-ing'
					disabled>
					{i18n.t('select.apply.btn')}
				</button>;
		}
		return (
			<div className="select-apply-wrapper">
				<div className="row justify-content-center">
					<div className="col-md-auto">
						<p className="caption">{i18n.t('select.apply.caption')}</p>
						<p className="text-center">
							{AuthButton}
						</p>
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(SelectApplyBtn);